export { EntidadLogoService } from './entidad-logo.service';
export { EntidadService } from './entidad.service';
export { TiposEntidadService } from './tipo-entidad.service';
